var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"container main_field"},[_c('Tableau',{ref:"tableau",attrs:{"url":_vm.url,"width":_vm.width,"height":_vm.height}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }